<script setup lang="ts">
withDefaults(defineProps<{
  usage?: 'footer' | 'teaser'
  headline?: string
  kicker?: string
}>(), {
  usage: 'footer',
  kicker: 'Kostenlose Newsletter-Anmeldung'
})
</script>

<template>
  <div :class="['bx-newsletter-subscription', 'bx-typo--newsletter-subscription', `bx-newsletter-subscription--${usage}`]">
    <div class="bx-newsletter-subscription__headline">
      {{ headline }}
    </div>
    <div v-if="usage === 'teaser'"
         class="bx-newsletter-subscription__kicker" />
    <a class="bx-button"
       href="/newsletter">
      {{ kicker }}
    </a>
  </div>
</template>
